<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
          v-model="listQuery.user_id"
          placeholder="用户ID"
          style="width: 180px"
          class="filter-item"
          clearable
      />
      <el-input
          v-model="listQuery.phone"
          placeholder="手机号"
          style="width: 180px"
          class="filter-item"
          clearable
      />

      <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
      >搜索</el-button
      >

      <el-button class="filter-item" type="primary" @click="downloadExcel">
        下载充值模板
      </el-button>
      <el-upload
          class="filter-item"
          accept=".xlsx,.xls"
          action=""
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleImportRecharge"
      >
        <el-button type="warning" icon="el-icon-upload"> 充值导入 </el-button>
      </el-upload>
      <!--      <span class="filter-item">-->
      <!--        <download-excel-->
      <!--            :fields="json_fields"-->
      <!--            :fetch="handleExport"-->
      <!--            type="xls"-->
      <!--            name="寄卖订单信息.xls"-->
      <!--            worksheet="寄卖订单信息"-->

      <!--        >-->
      <!--&lt;!&ndash;      :before-generate="startPost"-->
      <!--          :before-finish="endPost"                :header="header"&ndash;&gt;-->
      <!--          <el-button type="warning" :loading="exportLoading">-->
      <!--            导出订单信息-->
      <!--          </el-button>-->
      <!--        </download-excel>-->
      <!--      </span>-->
    </div>
    <div class="filter-container">
      <!-- <el-radio-group v-model="listQuery.status" size="small" @change="handleFilter">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="1">未匹配</el-radio-button>
        <el-radio-button label="2">待买家打款</el-radio-button>
        <el-radio-button label="3">已完成</el-radio-button>
        <el-radio-button label="4">已取消</el-radio-button>
      </el-radio-group> -->
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        element-loading-text="Loading"
        size="small"
        border
        fit
        highlight-current-row
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column align="center" label="ID" width="95" v-if="false">
        <template slot-scope="scope">
          {{ scope.row.id }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>

      <el-table-column label="头像" min-width="60" align="center">
        <template slot-scope="scope">
          <img
              :src="scope.row.user ? scope.row.user.avatar : '#'"
              class="user-avatar"
          />
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.account }}
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user ? scope.row.user.nickname : "-" }}
        </template>
      </el-table-column>

      <el-table-column label="余额" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.balance }}
        </template>
      </el-table-column>


      <el-table-column label="创建时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="handleAdd(scope.row, 1)" >充值</el-button>
          <el-button size="mini" type="danger" @click="handleDec(scope.row, 2)" >扣款</el-button>
          <el-button size="mini" type="primary" @click="handleCreate(scope.row)" >明细</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
          :current-page="listQuery.page"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="listQuery.limit"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>


    <div>
      <el-dialog
          :title= "balanceParam.type === 1 ? '余额充值' : '余额扣款'"
          :visible.sync="dialogFormVisible"
          width="700px"
      >
        <el-form
            ref="form"
            :rules="rules"
            :model="balanceParam"
            label-position="left"
            label-width="70px"
            style="width: 88%; margin-left:50px;"
        >
          <el-form-item label="金额" prop="money" ref="money">
            <el-input v-model="balanceParam.money"/>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false; balanceParam.money = '';">取消</el-button>
          <el-button type="primary" @click="editBalance" :loading="btnLoading">确定</el-button>
        </div>
      </el-dialog>
    </div>

    <el-dialog
        title="导入数据预览"
        :visible.sync="importDataDialogVisible"
        center
        width="60%"
        :close-on-click-modal="false"
    >
      <div style="height: 500px" class="scrollbar">
        <el-scrollbar style="height: 500px">
          <el-table :data="yulanData" style="width: 1100px">
            <el-table-column label="序号" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.index || "" }}
              </template>
            </el-table-column>
            <el-table-column label="电话" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.account || "" }}
              </template>
            </el-table-column>
            <el-table-column label="充值金额" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.money || "" }}
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="importDataDialogVisible = false">取消</el-button>
        <el-button @click="importSaveData" type="primary" :loading="btnLoading"
        >确认导入</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import walletAPI from "@/api/wallet";
import {excel2Json} from "@/utils/excel";

export default {
  data() {
    return {
      yulanData: [],
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: "",
        phone: "",
      },
      rules: {
        money: [{ required: true, message: "金额不能为空", trigger: "blur" }]
      },
      dialogFormVisible: false,
      btnLoading: false,
      exportLoading: false,
      form: {},
      dateArr: null,
      importDataDialogVisible:false,
      balanceParam: {
        user_wallet_id:'',
        money:'',
        type: '',
      },
    };
  },
  created() {
    this.getList();
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0];
        this.listQuery.end_at = newVal[1];
      } else {
        this.listQuery.start_at = "";
        this.listQuery.end_at = "";
      }
    },
  },
  methods: {
    downloadExcel() {
      let a = document.createElement("a");
      a.href = "/充值模板.xlsx";
      a.download = "充值模板.xlsx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    handleImportRecharge(file) {
      this.yulanData = [];
      file = file.raw;
      if (
          !(file.name.split(".")[1] == "xlsx" || file.name.split(".")[1] == "xls")
      ) {
        this.$message.error("上传文件格式不正确，请检查选择的文件");
        return;
      }
      excel2Json(file, 1).then((excelData) => {
        console.log(excelData);
        // 处理业务
        if (excelData.length <= 0) {
          this.$message.error("数据不能为空");
          return;
        }
        excelData.forEach((element, index) => {
          if (element["电话"]) {
            this.yulanData.push({
              index: element["序号"],
              account: element["电话"],
              money: element["金额"]
            });
          }
          console.log(element, "--------", index);
        });
        this.importDataDialogVisible = true;
        console.log(this.yulanData, "=============");
      });
    },
    importSaveData() {
      this.btnLoading = true;
      for (let index = 0; index < this.yulanData.length; index++) {
        const item = this.yulanData[index];
        for (var key in item) {
          if (!item[key]) {
            this.$message({
              type: "error",
              message: "请完善数据!!",
            });
            return;
          }
        }
      }
      request({
        url: "/api/backend/consignment/importRecharge",
        method: "post",
        data: {
          recharges: this.yulanData,
        },
      })
          .then((response) => {
            if (response.code == 0) {
              this.btnLoading = false;
              this.importDataDialogVisible = false;
              this.getList();
              this.$notify({
                type: "success",
                message: "操作成功!",
                showClose:true,
                duration:15*1000
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.btnLoading = false;
          })
          .finally(() => {
            this.btnLoading = false;
          });
    },
    // handleExport() {
    //   this.exportLoading=true;
    //   var query =JSON.parse(JSON.stringify(this.listQuery))  ;
    //   query.limit = 99999999999999;
    //   return request({
    //     url: "/api/backend/consignment/walletList",
    //     method: "post",
    //     params: query,
    //   })
    //       .then((result) => {
    //         var json_data = result.data.data;
    //         this.header = "寄卖订单信息";
    //         return json_data;
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       })
    //       .finally(() => {
    //         this.listLoading = false;
    //         this.exportLoading=false;
    //       });
    // },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/consignment/walletList",
        method: "post",
        params: this.listQuery,
      }).then((response) => {
        console.log(response);
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleEdit(object) {
      this.form = JSON.parse(JSON.stringify(object));
      this.dialogFormVisible = true;
    },
    handleAdd(object, $type){
      this.balanceParam.type = $type
      this.balanceParam.user_wallet_id = object.id
      this.dialogFormVisible = true;
    },
    handleDec(object, $type){
      this.balanceParam.type = $type
      this.balanceParam.user_wallet_id = object.id
      this.dialogFormVisible = true;
    },
    handleCreate(row) {
      this.$router.push(`/wallet/log?account=${row.user.account}`);
    },
    editBalance(){
      this.$refs['form'].validate((valid) => {
        if(valid) {
          if(this.balanceParam.type !== 1 &&this.balanceParam.money < 0.1) {
            this.$message.error('扣款金额不能小于0.1');
            return;
          }
          walletAPI.editBalance(this.balanceParam).then(res => {
            if (res.code === 0) {
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.dialogFormVisible = false;
              this.getList();
              this.balanceParam.money = '';
            }
          })
        }
      });

    },
    // saveData() {
    //   this.btnLoading = true;
    //   request({
    //     url: "/api/backend/task/save",
    //     method: "post",
    //     data: this.form,
    //   })
    //     .then((response) => {
    //       this.btnLoading = false;
    //       this.dialogFormVisible = false;
    //       this.$notify({
    //         title: "成功",
    //         message: "保存成功",
    //         type: "success",
    //         duration: 2000,
    //       });
    //       this.getList();
    //     })
    //     .catch((err) => {
    //       this.btnLoading = false;
    //     });
    // },
  },
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>